// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Fecha real de compl.: ',
    actualCompletionDateFull: 'Fecha real de finalización',
    AutoAssign_Issue: 'Asignar automáticamente nuevos problemas a:',
    AutoAssign_Note: 'El miembro elegido será asignado cada vez que se agregue una actividad al proyecto',
    AutoAssign_Request: 'Asignar automáticamente nuevas solicitudes a:',
    AutoAssign_Task: 'Asignar automáticamente nuevas tareas a:',
    AutoAssign_Title: 'Asignación automática',
    BaselineCapturedFeedback: 'La línea base del proyecto está capturada. Ve a una vista de diagrama de Gantt y elige la opción \'Mostrar\' para comprobarla.',
    BaselineCaptureLabel: 'Capturar línea base',
    BaselineOverwrite: '¿Sobrescribir la línea base actual?',
    BaselineOverwriteDescription: 'Ya tienes una línea base para este proyecto. Si continúas, la línea base actual se perderá.',
    BaselineOverwrittenFeedback: 'La línea base del proyecto ha sido sobrescrita. Ve a una vista de diagrama de Gantt y elige la opción \'Mostrar\' para comprobarla.',
    BaselineRecaptureLabel: 'Sobrescribir línea base',
    BaselineSuccess: 'La línea base se ha capturado correctamente.',
    Billed: 'Facturado',
    Billing: 'Facturación',
    BillingSettingsTitle: 'Configuración de facturación',
    BillingTypeNotBillable: 'No facturable',
    BillingTypeProjectBillingSettings: 'Configuración de facturación del proyecto',
    btnNotifications: 'Notificaciones',
    BudgetLeft: 'restante',
    BudgetTotal: 'total',
    By: 'por ',
    Change: 'cambiar',
    Close: 'Cerrar',
    ConfirmStatusDialogTitle: '¿Completar \"{0}\"?',
    CreateInvoice_Title: 'Crear factura',
    DayPluralFormat: '1#{0} día#{0} días',
    Days: '({0}d)',
    DeleteActivity: 'Eliminar actividad',
    DeleteProject: 'Eliminar proyecto',
    Dependencies_Count: '1#{0} dependencia#{0} dependencias',
    DifferPermissionsMessage: 'indica que los permisos del miembro actual del proyecto difieren de los permisos predeterminados del rol',
    Disable_Dates_Rollup: 'Desactivar agrupación de fechas',
    Disable_Dates_Rollup_Feedback: 'La agrupación de fechas ha sido desactivada',
    DueIn_Ok: 'vence en {0}',
    DueIn_Trouble: '{0} vencido',
    DueIn_Warning: 'vence hoy',
    EditRoleAndPermissions: 'Editar rol y permisos',
    Enable_And_Reschedule: 'Activar y reprogramar',
    Enable_Dates_Rollup: 'Activar agrupación de fechas',
    Enable_Dates_Rollup_Description: 'Al activar la agrupación de fechas, este proyecto se reprogramará.',
    Enable_Dates_Rollup_Feedback: 'La agrupación de fechas ha sido activada',
    Enable_Dates_Rollup_Title: 'Las fechas del proyecto se actualizarán',
    endDate: 'Fecha fin planificada: ',
    endDateFull: 'Fecha fin planificada',
    endLessThenStartMsg: '\'Fecha de fin\' no puede ser menor que \'Fecha de inicio\'',
    estimatedHours: '1# hora estimada# horas estimadas',
    ExportToMsProject: 'Exportar a MS Project',
    Fields: '1#{0} campo#{0} campos',
    FillCustomFields: '{0} aún debe completarse',
    Follow: 'Seguir',
    follow_all_activities_label: 'Seguir todas las actividades',
    hide_checklist_label: 'Ocultar lista de comprobación',
    HideCustomFields: 'Ocultar campos personalizados',
    hoursLeft: '1# hora restante# horas restantes',
    HoursOf: 'h de ',
    HtmlField_ReadAll: '... leer todo',
    ImDoneText: 'He terminado',
    invoice_creation_no_customer_disabled_reason: 'Selecciona un cliente para poder crear una factura',
    IsMilestone: 'Esto es un hito',
    issue: 'Incidencia',
    MarkAsMilestone: 'Marcar como hito',
    MemberPermission_Add: 'Agregar',
    MemberPermission_Add_For_Someone_Else: 'Agregar para otra persona',
    MemberPermission_Add_Own: 'Agregar propio',
    MemberPermission_CanEditActualExpenses: 'Editar todos los reales',
    MemberPermission_CanEditPlannedExpenses: 'Editar todos los planificados',
    MemberPermission_CanLogExpenses: 'Agregar propio',
    MemberPermission_CanManageProjectMembers: 'Gestionar miembros y permisos',
    MemberPermission_CanManageProjectMembersAndAllocations: 'Gestionar miembros, permisos y asignaciones',
    MemberPermission_CanViewAllExpenses: 'Ver todos',
    MemberPermission_CanViewMembersAndAssignees: 'Ver',
    MemberPermission_Delete: 'Eliminar',
    MemberPermission_Delete_All: 'Eliminar todos',
    MemberPermission_Delete_Or_Archive: 'Eliminar/Archivar',
    MemberPermission_Edit: 'Editar',
    MemberPermission_Edit_All: 'Editar todos',
    MemberPermission_Edit_Assigned: 'Editar asignado',
    MemberPermission_Manage_Assigned: 'Gestionar asignados',
    MemberPermission_View_All: 'Ver todos',
    MemberPermission_View_and_Manage: 'Ver y gestionar',
    MemberPermission_View_Assigned: 'Ver asignados',
    MemberPermissions_ExpensesTitle: 'Gastos:',
    MemberPermissions_MembersAndAssigneesTitle: 'Miembros y asignados:',
    MemberPermissions_TasksTitle: 'Actividades:',
    MemberPermissions_ThisProjectTitle: 'Proyecto:',
    MemberPermissions_TimeEntriesTitle: 'Entradas de tiempo:',
    Members: '1#{0} miembro#{0} miembros',
    no_assignee: 'Sin asignado',
    On: 'el ',
    OwnBudget: 'Presupuesto para esta actividad:',
    PercentDone: '1#% completado#% completado',
    PermissionsSettingsTitle: 'Permisos de {0}',
    project: 'Proyecto',
    Project_NotFound_Message: 'No se pudo encontrar el proyecto solicitado, o no tienes permiso para acceder a él. Consulta con tu administrador de {brandName} para conocer las posibles causas. La clave del objeto es {0}.',
    Project_NotFound_Title: 'Proyecto solicitado no encontrado',
    Project_WasCompleted_Ok: 'El proyecto se completó <b>{0} antes</b> de su fecha fin planificada',
    Project_WasCompleted_Trouble: 'El proyecto se completó <b>{0} después</b> de su fecha fin planificada',
    Project_WasCompleted_Warning: 'El proyecto se completó en su fecha fin planificada',
    RatioOfMoneySpent: '1#{0} de {1} gastado#{0} de {1} gastado',
    RepeatActivity: 'Repetir',
    request: 'Solicitud',
    ResumeWorkHelpText: 'Has completado tu asignación. ',
    ResumeWorkText: 'Reanudar trabajo',
    RoleTitle: 'Rol para este proyecto',
    Save: 'Guardar',
    Set_actualCompletionDate: 'Establecer fecha de finalización real',
    Set_budget: 'Establecer presupuesto',
    Set_categoryId: 'Establecer categoría',
    Set_customerId: 'Establecer cliente',
    Set_dates: 'Establecer fechas o duración',
    Set_description: 'Agregar descripción',
    Set_endDate: 'Establecer fecha de finalización planificada',
    Set_estimatedHours: 'Establecer horas estimadas',
    Set_hoursLeft: 'Establecer horas restantes',
    Set_labor_budget: 'Establecer presupuesto laboral',
    Set_portfolioId: 'Establecer portafolio',
    Set_short_hoursLeft: 'Establecer horas restantes',
    SetAsRootLevel: 'Establecer como actividad de nivel superior',
    SetCompleted: 'Marcar como completada',
    short_hoursLeft: 'Queda 1# hora# Quedan # horas',
    show_checklist_label: 'Mostrar lista de verificación',
    ShowCustomFields: 'Mostrar campos personalizados',
    Spent: '1#h gastada#h gastadas',
    Status: 'Estatus: ',
    task: 'Tarea',
    Task_NotFound_Message: 'No se pudo encontrar la actividad solicitada o no tiene permiso para acceder a ella. Consulte con su administrador de {brandName} para posibles causas. La clave del objeto es {0}.',
    Task_NotFound_Title: 'No se encontró la actividad solicitada',
    Task_WasCompleted_Ok: 'La actividad se completó <b>{0} antes</b> de la fecha de finalización planificada',
    Task_WasCompleted_Trouble: 'La actividad se completó <b>{0} después</b> de la fecha de finalización planificada',
    Task_WasCompleted_Warning: 'La actividad se completó en la fecha de finalización planificada',
    today: 'Hoy',
    UnFollow: 'Dejar de seguir',
    unfollow_all_activities_label: 'Dejar de seguir todas las actividades',
    WindowUnload_UnsavedChanges: 'Hay cambios sin guardar. ¿Está seguro de que desea abandonar esta página?',
};
